/* Props:
  - onClick: función que se ejecuta al hacer clic en el botón
  - texto: texto personalizado del botón (si no se envía, se usa el predeterminado según el tipo)
  - type: define el tipo de botón (afecta estilos y texto por defecto)
  - className: clases CSS adicionales para personalización externa
  - disabled: si es true, desactiva el botón y cambia su apariencia */

const Button = ({ onClick, texto, type = 'register', className = '', disabled = false }) => {
  // Estilos base que aplican a todos los botones
  const baseStyles = 'px-3 py-1 rounded border focus:outline-none transition duration-200 ease-in-out'
  // Estilos para cuando el botón está deshabilitado
  const disabledStyles = 'opacity-50 cursor-not-allowed'
  // Estilos según el tipo de botón (colores y efectos hover)
  const styleVariants = {
    register: 'bg-[#2b6cb0] text-white border-[#2b6cb0] hover:bg-[#2c5282] hover:border-[#2a4365]', 
    delete: 'bg-red-500 text-white border-red-600 hover:bg-red-600 hover:border-red-800',        
    update: 'bg-gray-200 text-black border-gray-300 hover:bg-gray-300 hover:border-gray-500',   
    consult: 'bg-green-500 text-white border-green-600 hover:bg-green-600 hover:border-green-800', 
    report: 'bg-[#7e22ce] text-white border-[#7e22ce] hover:bg-[#6b21a8] hover:border-[#4c1d95]',      
    cancel: 'bg-gray-400 text-white border-gray-500 hover:bg-gray-500 hover:border-gray-600',       
    save: 'bg-[#17a589] text-white border-[#148f77] hover:bg-[#148f77] hover:border-[#0e6251]',
  }
  //Textos por defecto según el tipo de botón
  const textVariants = {
    register: 'Registrar',
    delete: 'Eliminar',
    update: 'Actualizar',
    consult: 'Consultar',
    report: 'Reporte',
    cancel: 'Cancelar',
    save: 'Registrar',
  }

  return (
    <button 
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${styleVariants[type]} ${disabled ? disabledStyles : ''} ${className}`}
      title={disabled ? 'Seleccione una fila de la tabla' : ''}>
        {texto || textVariants[type] || 'Botón'}
    </button>
  )
}

export default Button

